<template>
  <div class="contact-wrapper">
    <div class="focus-wrapper">
      <span class="focus-title"></span>
      <span class="focus-logo"></span>
      <Nav class="head-nav"></Nav>
    </div>
    <div class="contact-content">
      <div class="md-container">
        <span class="lxwm"></span>
        <p class="contact-tel">
          合伙人热线：<a href="tel:400-000-0000">400-891-0589</a>
        </p>
        <div class="dj-wrap">
          <a :href="link" class="dj-btn" target="_blank"></a>
          <div class="qr-code-wrap">
            <img :src="qrCodeImg" width="100%" height="auto" alt="">
            <p class="scan-text">手机扫一扫填写登记信息</p>
          </div>
        </div>
        <div class="img-box">
          <img src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/A5892DCC07E841B8855029C393DF04EB-6-2.png" width="100%" height="auto"
            alt="">
          <img src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/33377C49F79C43AB81721086BB128C51-6-2.png" width="100%" height="auto"
            alt="">
        </div>
        <ul class="franchise-conditions">
          <li v-for="(item, index) in conditions" :key="index">
            <b>{{ item.title }} </b>
            <p v-for="(text, i) in item.content" :key="i"> {{ text }}</p>
          </li>
        </ul>

      </div>
    </div>

    <Foot color="#fdf8ed"></Foot>
  </div>
</template>
<script>
import Foot from "../components/Foot.vue";
import Nav from "../components/Nav.vue";
export default {
  components: {
    Foot,
    Nav
  },
  computed: {
    conditions() {
      return this.$globalData.contact.conditions;
    },
    link() {
      return this.$globalData.contact.franchise_link;
    },
    qrCodeImg() {
      return this.$globalData.contact.franchise_qr_code;
    }
  }
}
</script>
<style lang="less" scoped>
@media(max-width: 1200px) {
  .contact-wrapper {
    div.md-container {
      width: 100% !important;
    }

    .contact-content {
      padding-bottom: 1.2vw !important;
      div.md-container {
        width: 100% !important;
   

        .lxwm {
          width: 21.5vw !important;
          height: 8.65vw !important;
          margin: 8.5vw 0 0 3.688vw !important;
        }

        .contact-tel {
          font-size: 7.98vw !important;
          padding: 0 !important;
          width: 100% !important;
          margin: 4.8vw auto !important;
          line-height: 7.98vw !important;
          text-align: center !important;
        }

        .dj-wrap {
          flex-direction: column;

          .dj-btn {
            width: 60% !important;
            transform: scale(1) !important;
            height: 15vw !important;
            margin: 0 auto !important;
          }

          .qr-code-wrap {
            margin: 0 auto !important;
            width: 40% !important;
            position: relative;
            p {
              width: 100vw !important;
              text-align: center;
              font-size: 4.2vw !important;
              line-height: 4.2vw !important;
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }

        .img-box {
          padding: 0 3.688vw;
          box-sizing: border-box;
        }
        .franchise-conditions{
          padding: 0 3.688vw !important;
          li{
            margin-bottom: 0.8vw !important;
            b{
              font-size: 4.28vw !important;
              line-height: 12.85vw !important;
            }
            p{
              font-size: 3.28vw !important;
              line-height: 5.88vw !important;
            }
          }
        }
      }
    }
  }
}

@media(max-width: 1560px) {
  .contact-wrapper {
    .md-container {
      width: 1200px !important;
    }

    .head-nav {
      bottom: 0 !important;
    }

    .contact-content {
      .md-container {
        width: 1200px !important;
      }
    }
  }

}

.focus-wrapper {
  background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/wenli_bg.png") repeat;
  width: 100%;
  height: 870px;
  position: relative;
  border-bottom: 3px solid #ffffff;

  .head-nav {
    position: absolute;
    left: 0;
    bottom: 154px;
  }
}

.contact-content {
  background: #fdf8ed;
  padding-bottom: 120px;

  .md-container {
    width: 1400px !important;
  }

  .franchise-conditions {
    list-style: none;
    padding: 0 0 0 30px;
    margin: 0;

    li {
      list-style: none;
      text-align: left;
      margin-bottom: 38px;

      b {
        color: #231815;
        font-size: 30px;
        font-weight: bold;
        line-height: 86px;
      }

      p {
        color: #231815;
        line-height: 40px;
        font-size: 24px;
      }
    }
  }

  .lxwm {
    display: block;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/lxwm.png) no-repeat top center;
    width: 325px;
    height: 125px;
    background-size: 100%;
    margin-top: 104px;
  }

  .contact-tel {
    font-size: 68px;
    font-family: hanli-min, HL0811,Hl0906,Hl1126;
    text-align: left;
    color: #473935;
    line-height: 42px;
    margin: 156px 0;
    padding-left: 24px;

    a {
      color: #473935;
    }
  }

  .dj-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .dj-btn {
      background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/dj_btn.png) no-repeat top center;
      width: 660px;
      height: 117px;
      background-size: 100%;
      display: block;
      transform: scale(0.8);
      transform-origin: 0 0;
    }

    .qr-code-wrap {
      width: 226px;
      margin-right: 40px;

      .scan-text {
        font-size: 20px;
        color: #473935;
        text-align: center;
        line-height: 36px;
        font-family: hanli-min, hanli;
        letter-spacing: -1px;
      }
    }
  }



}
</style>